import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import InvoiceDate from './InvoiceDate'

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 30,
        display: 'flex',
        flexDirection: 'row',
    },
    billTo_section: {
        justifyContent: 'left'
    },
    billTo: {
        paddingBottom: 3,
        // fontFamily: 'Helvetica-Oblique',
        width: 100,
        color: '#c00000',
        textDecoration: 'underline',
    },
    name: {
        fontSize: 15,
        color: '#c00000',
    },
    address: {
        width: '250px',
        fontStyle: "italic",
    }
  });


  const BillTo = ({invoice}) => (
    <View style={styles.headerContainer}>
        <View style={styles.billTo_section}>
            <Text style={styles.billTo}>BILL TO</Text>
            <Text style={styles.name}>{invoice.cust_name}</Text>
            <Text style={styles.address}>{invoice.cust_address}</Text>
            <Text>Ph: {invoice.cust_phone}, Email: {invoice.cust_email}</Text>
            {/* <Text>Email: {invoice.cust_email}</Text> */}
            <Text style={styles.gst_in}>{invoice.cust_gst_in}</Text>
        </View>
        <InvoiceDate invoice={invoice}/>
    </View>
  );
  
  export default BillTo